<template>
  <PriceAssessmentsTab :product="product" />
</template>

<script lang="ts" setup>
import PriceAssessmentsTab from '~/components/reports/PriceAssessmentsTab.vue'
import type { TProduct } from '~/src/types/product'
/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
}>()
</script>
